module.exports = __webpack_public_path__ + "assets/img/2.8b3c8ecc.png";